export default function CTASection() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/258869689262?text=Olá! Gostaria de fazer um pedido de Crocs personalizado.', '_blank');
  };

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-gradient-to-br from-orange-500 via-pink-500 to-yellow-500 rounded-3xl overflow-hidden shadow-2xl">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full"></div>
            <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full"></div>
            <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-white rounded-full"></div>
          </div>

          <div className="relative px-8 py-16 md:px-16 md:py-20 text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-whatsapp-line text-5xl text-white"></i>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Pronto Para Seu Crocs Único?
            </h2>
            
            <p className="text-xl text-white/90 mb-4 max-w-2xl mx-auto">
              Escolha sua cor favorita entre 20 opções vibrantes
            </p>
            
            <p className="text-2xl font-bold text-white mb-8">
              Todos por apenas 1.800 MZN
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
              <button
                onClick={handleWhatsAppClick}
                className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 text-lg font-semibold rounded-full hover:bg-gray-100 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full">
                  <i className="ri-whatsapp-line text-xl text-white"></i>
                </div>
                Pedir no WhatsApp
              </button>
              
              <a
                href="#produtos"
                className="inline-flex items-center gap-3 px-10 py-5 bg-white/20 text-white text-lg font-semibold rounded-full hover:bg-white/30 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                Ver Modelos
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-xl"></i>
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-white">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-2xl"></i>
                </div>
                <span className="font-semibold">20 Cores</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-2xl"></i>
                </div>
                <span className="font-semibold">Pins Decorativos</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-2xl"></i>
                </div>
                <span className="font-semibold">Entrega Rápida</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
